export interface FeatureToggleState {
  benes_by_relation: boolean;
  save_as_draft: boolean;
  control_person: boolean;
  gifting: boolean;
  gifting_scale_v2: boolean;
  cwp_ira_scale_trad: boolean;
  cwp_ira_scale_inh_roth: boolean;
  cwp_ira_scale_estate: boolean;
  cwp_ira_scale_trust: boolean;
  cwp_ira_scale_trust_to_trust: boolean;
  cwp_inheritance_ira_question: boolean;
  cwp_internal_gifting_managed_accounts: boolean;
  intelledox_redirect_and_thresholds: boolean;
  joint_inheritance: boolean;
  inheritance_ira: boolean;
  inheritance_individual: boolean;
  doc_checklist_inheritance: boolean;
  cwp_multi_inheritance: boolean;
  cwp_multi_inheritance_estate: boolean;
  cwp_inheritance_save_draft: boolean;
  cwp_inheritance_save_draft_internal: boolean;
  cwp_co0_minor: boolean;
  cwp_co0_inheritance: boolean;
  cwp_co0_internal_transfers: boolean;
  cwp_co0_upload: boolean;
  cwp_co0_gifting: boolean;
  cwp_divorce: boolean;
  cwp_gifting_advised_accounts: boolean;
  cwp_it_multi_receiving: boolean;
  cwp_multi_transactions_crew: boolean;
  cwp_account_validation: boolean;
  cwp_inheritance_vcd: boolean;
  togglesLoaded: boolean;
  cwp_prospect_to_auth_first: boolean;
  l8_itw_upload: boolean;
  cwp_vc_org_to_org: boolean;
  cwp_non_vc_org_transfer: boolean;
  cwp_document_upload_mfe: boolean;
  cwp_inheritance_org_as_bene: boolean;
  cwp_mo_gifting: boolean;
  cwp_inheritance_individual_joint_to_trust: boolean;
  cwp_inheritance_restrict_dup_transactions: boolean;
  cwp_inheritance_decedent_security: boolean;
  cwp_inheritance_checklist_get_started: boolean;
  cwp_terms_w9_redesign: boolean;
  cwp_multi_it_mo: boolean;
  cwp_inheritance_advised_client_warnings: boolean;
  cwp_inheritance_save_state: boolean;
  cwp_inheritance_new_terms: boolean;
  cwp_minor_save_draft: boolean;
  cwp_cash_plus_sweep_transfer: boolean;
  cwp_buy_sell_home_url_routing: boolean;
  cwp_viadoc_shadow_mode: boolean;
}
